import { requestToken } from "./request_method";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/service`;

class ServicingApi {
  // Servicing List
  async getServicingList() {
    try {
      const response = await requestToken.get(API_ROUTE + "/getServicingList");
      return response;
    } catch (error) {
      console.error("getServicingList", error);
      throw error;
    }
  }
  async createServiceListItem(payload) {
    try {
      const response = await requestToken.post(API_ROUTE + "/servicelist", payload);
      return response;
    } catch (error) {
      console.error("createServiceListItem", error);
      throw error;
    }
  }
  async updateServiceListItem(id, payload) {
    try {
      const response = await requestToken.put(API_ROUTE + `/servicelist/${id}`, payload);
      return response;
    } catch (error) {
      console.error("updateServiceListItem", error);
      throw error;
    }
  }
  async deleteServiceListItem(id) {
    try {
      const response = await requestToken.delete(API_ROUTE + `/servicelist/${id}`);
      return response;
    } catch (error) {
      console.error("deleteServiceListItem", error);
      throw error;
    }
  }
  async toggleServiceListActive(id, is_active) {
    try {
      const response = await requestToken.patch(API_ROUTE + `/servicelist/${id}/active`, { is_active });
      return response;
    } catch (error) {
      console.error("toggleServiceListActive", error);
      throw error;
    }
  }
  // Vehicle servicing List
  async getServicingVehicles(payloads) {
    try {
      let action = API_ROUTE + `/getServicingVehicles`;
      const response = await requestToken.post(action, payloads);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  // Vehicle servicing List
  async getCompleteCustomerInfo() {
    try {
      let action = API_ROUTE + `/getCompleteCustomerInfo`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  // add Follow up
  async addServiceFollowup(payloads) {
    try {
      let action = API_ROUTE + `/serviceFollowup`;
      const response = await requestToken.post(action, payloads);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getServiceFollowup(customer_id, service_id) {
    try {
      let action =
        API_ROUTE +
        `/serviceFollowup?customer_id=${customer_id}&service_id=${service_id}`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getDueServicesToday() {
    try {
      let action = API_ROUTE + "/due-today";
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async createNextServiceFollowUp(payload) {
    try {
      let action = API_ROUTE + `/create-follow-up`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async updateLastServices(payload) {
    try {
      let action = API_ROUTE + `/last-service`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async updateActualHours(payload) {
    try {
      let action = API_ROUTE + `/actual-hour`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async submitTractorStatus(payload) {
    try {
      let action = API_ROUTE + `/tractor-status`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getSoldTractorLogs(payload) {
    try {
      let action = API_ROUTE + "/sold-tractor-logs";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getITLServicesLog(payload) {
    try {
      let action = API_ROUTE + `/itl-service-log`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getPdfContentLogs(payload) {
    try {
      let action = API_ROUTE + `/pdf-content`;
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async undoSoldOutStatus(payload) {
    try {
      let action = API_ROUTE + "/undo-status";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
}

export default ServicingApi;
